module.exports = __webpack_public_path__ + "img/boost-icon.3436cb5f.svg";